function getLeadTimeDisplay(material, nextIncomingDate, inventory, quantity) {
    if (Number(inventory) >= Number(quantity)) {
        return { leadTime: "Ready to Ship", preOrder: false };
    }

    let leadTimeDisplay = "Estimated to ship in 12 to 16 weeks";

    const mat = Array.isArray(material) ? material[0] : material;

    if (["Zellige", "Marble", "Terrazzo", "Moroccan Stone"].includes(mat)) {
        leadTimeDisplay = "Estimated to ship in 12 to 16 weeks";
    } else if (["Slate"].includes(mat)) {
        leadTimeDisplay = "Estimated to ship in 8 to 14 weeks";
    } else if (["Breeze Block", "Ceramic"].includes(mat)) {
        leadTimeDisplay = "Estimated to ship in 4 to 8 weeks";
    } else if (mat === "Cement") {
        leadTimeDisplay = "Contact us for more information";
    }

    if (nextIncomingDate) {
        const dateObj = new Date(nextIncomingDate);

        if (!isNaN(dateObj.getTime())) {
            const leadTimeDate = dateObj.getDate();
            const leadTimeMonth = dateObj.toLocaleString("en-US", { month: "long" });
            const leadTimeYear = dateObj.getFullYear();

            let leadTimePeriod = "Late";
            if (leadTimeDate <= 10) {
                leadTimePeriod = "Early";
            } else if (leadTimeDate <= 20) {
                leadTimePeriod = "Mid";
            }

            leadTimeDisplay = `Estimated to ship by ${leadTimePeriod} ${leadTimeMonth} ${leadTimeYear}`;
        }
    }

    return { leadTime: leadTimeDisplay, preOrder: true };
}


function check_minimum_sq_ft_per_order(min_sq_per_order, totalSquateFeet) {
    const min_sq = Number(min_sq_per_order);
    const total_sq = Number(totalSquateFeet);

    console.log(min_sq, " ", total_sq, " In PUB SUB");

    if (!isNaN(min_sq) && !isNaN(total_sq) && total_sq >= min_sq) {
        return true;
    } else {
        alert(`The minimum quantity should be ${min_sq} sqft for order.`);
        return false;
    }
}


function getItemProperties(
    itemProperties,
    isIncoming,
    incomingDate,
    inventory,
    min_sq_per_order,
    material,
    quantity
) {
    let boxOrBundle = "";

    if ("Boxes" in itemProperties) {
        boxOrBundle = "Boxes";
    } else if ("Bundle" in itemProperties) {
        boxOrBundle = "Bundle";
    }

    const lead = getLeadTimeDisplay(
        material,
        incomingDate,
        inventory,
        quantity
    );

    itemProperties["Lead Time"] = lead.leadTime;

    if (lead.preOrder) {
        itemProperties["Item Type"] = "Pre-Order";
    } else {
        delete itemProperties["Item Type"];
    }

    let sq_ft;

    // =========================
    // SQ.FT PRODUCTS
    // =========================
    if ("Total Sq.Ft" in itemProperties) {
        if (!boxOrBundle || !itemProperties[boxOrBundle]) {
            console.warn("Missing Boxes/Bundle for Sq.Ft product", itemProperties);
            return { itemProperties, sq_ft: 0 };
        }

        const base = Number(itemProperties["Total Sq.Ft"]);
        const divisor = Number(itemProperties[boxOrBundle]);

        if (!isNaN(base) && !isNaN(divisor) && divisor > 0) {
            sq_ft = base / divisor;
            itemProperties["Total Sq.Ft"] = (sq_ft * quantity).toString();
            itemProperties[boxOrBundle] = quantity.toString();
        }
    }

    // =========================
    // LINEAR FT PRODUCTS (FIXED)
    // =========================
    else if ("Total Linear.Ft" in itemProperties) {
        if (!boxOrBundle || !itemProperties[boxOrBundle]) {
            console.warn("Missing Boxes/Bundle for Linear.Ft product", itemProperties);
            return { itemProperties, sq_ft: 0 };
        }

        const base = Number(itemProperties["Total Linear.Ft"]);
        const divisor = Number(itemProperties[boxOrBundle]);

        if (!isNaN(base) && !isNaN(divisor) && divisor > 0) {
            sq_ft = base / divisor;
            itemProperties["Total Linear.Ft"] = (sq_ft * quantity).toString();
            itemProperties[boxOrBundle] = quantity.toString();
        }
    }

    return { itemProperties, sq_ft: sq_ft || 0 };
}


eventBus.subscribe(PUB_SUB_EVENTS.quantityUpdatePreOrder, (event) => {
    console.log("event", event.item);

    const quantity = Number(event.quantity);

    let itemProperties = event.item.properties;
    let oldItemProperties = event.item.properties;

    const incomingDate = event.target.getAttribute("variant-incomeing-date");
    const inventory = event.target.getAttribute("variant-inventory-quantity");
    const min_sq_per_order = event.target.getAttribute("minmun_per_order");

    const material = event.target.getAttribute("material")
        ? JSON.parse(event.target.getAttribute("material"))
        : [];

    const result = getItemProperties(
        itemProperties,
        false,
        incomingDate,
        inventory,
        min_sq_per_order,
        material,
        quantity
    );

    itemProperties = result.itemProperties;

    const isMinOrder = check_minimum_sq_ft_per_order(
        min_sq_per_order,
        itemProperties["Total Sq.Ft"] || itemProperties["Total Linear.Ft"]
    );

    console.log("Minimum order", isMinOrder);

    if (isMinOrder) {
        return {
            properties: itemProperties,
            satisfyMin: true,
            quantity: quantity
        };
    }

    const sq_ft = result.sq_ft || 0;

    const minQuantityNeeded =
        sq_ft > 0 && !isNaN(sq_ft)
            ? Math.ceil(Number(min_sq_per_order) / sq_ft)
            : quantity;

    console.log(minQuantityNeeded);

    oldItemProperties = getItemProperties(
        itemProperties,
        false,
        incomingDate,
        inventory,
        min_sq_per_order,
        material,
        minQuantityNeeded
    ).itemProperties;

    return {
        properties: oldItemProperties,
        satisfyMin: false,
        quantity: minQuantityNeeded
    };
});